/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Clean_WhitespaceInputs */

const en_dialog_text_to_audio_clean_whitespace = /** @type {(inputs: Dialog_Text_To_Audio_Clean_WhitespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean up whitespace`)
};

const es_dialog_text_to_audio_clean_whitespace = /** @type {(inputs: Dialog_Text_To_Audio_Clean_WhitespaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar espacios`)
};

/**
* | output |
* | --- |
* | "Clean up whitespace" |
*
* @param {Dialog_Text_To_Audio_Clean_WhitespaceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_clean_whitespace = /** @type {((inputs?: Dialog_Text_To_Audio_Clean_WhitespaceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Clean_WhitespaceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_clean_whitespace(inputs)
	return en_dialog_text_to_audio_clean_whitespace(inputs)
});